// extracted by mini-css-extract-plugin
export default {"departments":"HF-z","departmentHeading":"IF-z","departmentSection":"JF-z","departmentName":"KF-z","departmentLink":"LF-z","expandIcon":"MF-z"};